import { type ObjectMode } from '@databases/types';
import { type Database, DatabaseFieldType } from '@databases/types/database';
import { createField, getExistingDatabase } from '@databases/utils/database/utils';

import { generateValuesForEntriesById } from '../utils';

import { databasesToContentId } from './constants';

export const getDatabaseWithUserAndLinkField = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getExistingDatabase({
    contentId: databasesToContentId['databaseWithUserAndLinkField']
  });

  const hyperLinkField = createField(DatabaseFieldType.HYPERLINK);
  const fields = [
    {
      ...createField(DatabaseFieldType.USER),
      name: `User Field`
    },
    {
      ...hyperLinkField,
      name: `Link Field`,
      settings: {
        ...hyperLinkField.settings,
        multi: true
      }
    }
  ];

  const entriesById = generateValuesForEntriesById(baseDatabase.entries, fields);

  return {
    ...baseDatabase,
    fields: fields.map((field) => field.id),
    fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
    entriesById,
    entries: Object.keys(entriesById)
  };
};
